export default function ProblemSection() {
  return (
    <section className="bg-[#0A0A0A] py-32 lg:py-40">
      <div className="max-w-[1200px] mx-auto px-6 lg:px-12">
        {/* Section Label */}
        <div className="flex justify-center mb-10">
          <span className="inline-block bg-[#00FF88] text-black text-xs font-bold uppercase tracking-wider px-5 py-2 rounded-full">
            The Problem
          </span>
        </div>

        {/* Headline */}
        <h2 className="text-5xl lg:text-7xl font-bold text-white text-center mb-16 leading-tight max-w-[900px] mx-auto">
          Your Fuel Should Adapt To Your Training
        </h2>

        {/* Body Copy - Two Columns */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 mb-20">
          <div>
            <p className="text-lg lg:text-xl text-white/70 leading-relaxed">
              Maurten locks you into 500ml. Gatorade under-doses electrolytes for serious efforts. Most caffeine products bundle it with carbs so you can't control either. Every product forces a formula built for the average athlete — not for your distance, your sweat rate, or your race.
            </p>
          </div>
          <div>
            <p className="text-lg lg:text-xl text-white/70 leading-relaxed">
              A 3-hour training ride needs different fuel than a 10-hour Ironman. A hot race needs more sodium than a cool morning run. Your carb tolerance on week 12 of training is not the same as week 1. Your fuel should be as dialed as your training plan.
            </p>
          </div>
        </div>

        {/* Visual Comparison */}
        <div className="flex flex-col items-center gap-12">
          {/* Old Way */}
          <div className="relative">
            <div className="flex flex-wrap justify-center gap-6 opacity-40">
              <div className="w-24 h-32 bg-gradient-to-b from-gray-700 to-gray-800 rounded-lg relative">
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-16 h-20 bg-gray-600 rounded"></div>
                </div>
              </div>
              <div className="w-24 h-32 bg-gradient-to-b from-gray-700 to-gray-800 rounded-lg relative">
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-16 h-20 bg-gray-600 rounded"></div>
                </div>
              </div>
              <div className="w-24 h-32 bg-gradient-to-b from-gray-700 to-gray-800 rounded-lg relative">
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-16 h-20 bg-gray-600 rounded"></div>
                </div>
              </div>
            </div>
            <div className="absolute inset-0 flex items-center justify-center">
              <div className="w-32 h-32 rounded-full bg-red-500/20 border-4 border-red-500 flex items-center justify-center">
                <i className="ri-close-line text-6xl text-red-500"></i>
              </div>
            </div>
          </div>

          {/* Arrow Down */}
          <div className="flex flex-col items-center gap-2">
            <i className="ri-arrow-down-line text-4xl text-[#00FF88]"></i>
            <p className="text-[#00FF88] font-bold text-sm uppercase tracking-wider">The THRESH Way</p>
          </div>

          {/* New Way */}
          <div className="flex flex-wrap justify-center gap-8">
            <div className="w-28 h-36 bg-gradient-to-b from-[#00FF88]/20 to-[#00FF88]/10 rounded-xl border-2 border-[#00FF88] relative overflow-hidden group hover:scale-105 transition-transform cursor-pointer">
              <div className="absolute inset-0 flex flex-col items-center justify-center p-4">
                <i className="ri-flask-line text-4xl text-[#00FF88] mb-2"></i>
                <span className="text-white font-bold text-xs uppercase">Carbs</span>
              </div>
            </div>
            <div className="w-28 h-36 bg-gradient-to-b from-[#00FF88]/20 to-[#00FF88]/10 rounded-xl border-2 border-[#00FF88] relative overflow-hidden group hover:scale-105 transition-transform cursor-pointer">
              <div className="absolute inset-0 flex flex-col items-center justify-center p-4">
                <i className="ri-drop-line text-4xl text-[#00FF88] mb-2"></i>
                <span className="text-white font-bold text-xs uppercase">Electrolytes</span>
              </div>
            </div>
            <div className="w-28 h-36 bg-gradient-to-b from-[#00FF88]/20 to-[#00FF88]/10 rounded-xl border-2 border-[#00FF88] relative overflow-hidden group hover:scale-105 transition-transform cursor-pointer">
              <div className="absolute inset-0 flex flex-col items-center justify-center p-4">
                <i className="ri-flashlight-line text-4xl text-[#00FF88] mb-2"></i>
                <span className="text-white font-bold text-xs uppercase">Caffeine</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}